// extracted by mini-css-extract-plugin
export default {"Black":"#333D47","currentSetting":"G981354"};